export default "__VITE_ASSET__aMArDAx0__"